import React, { Component } from 'react';
import { Stage, Text, TextPath, Layer, Group } from "react-konva";
import { connect } from 'react-redux';
import request from 'request';

import CachedImage from '../components/CachedImage';

import _map from 'lodash/map';
import _each from 'lodash/each';
import SvgSticker from "../components/SvgSticker";
// import CanvasLayer from "../components/CanvasLayer";

class Exporter extends Component {

  group = null;
  stages = {};

  constructor(props) {
    super(props);

    this.renderText = this.renderText.bind(this);
    this.renderImage = this.renderImage.bind(this);
    this.renderSticker = this.renderSticker.bind(this);
    this.renderSurface = this.renderSurface.bind(this);
    this.export = this.export.bind(this);
    this.exportImages = this.exportImages.bind(this);
  }

  /*
        $payload = [
          'product' => (int) $product->getId(),
          'color' => (int) $color->getId(),
          'surfaces' => $product->getSurfaces()->map(function (ProductSurface $surface) {
              return [
                  'id' => (int) $surface->getId(),
                  'data' => ['layer' => 1],
                  'image' => 'https://placehold.it/255x255'
              ];
          })->toArray(),
          'sizes' => $product->getSizes()->map(function (ProductSize $size) {
              return [
                  'id' => (int) $size->getId(),
                  'amount' => $size->getId() + 1
              ];
          })->toArray()
      ];

 */

  exportPreviewImages() {
    const paperX = 550;
    const paperY = 910 * 1.1;
    const y = paperY * 0.1;
    const height = paperY - y;

    return _map(this.stages, (stage, surfaceId) => {
      return stage.getStage().toDataURL({mimeType: 'image/png', pixelRatio: 1, x: 0, y: paperY * 0.1, width: paperX, height: height});
    });
  }

  exportImages() {
    return _map(this.stages, (stage, surfaceId) => {
      return stage.getStage().toDataURL({mimeType: 'image/png', pixelRatio: 1});
    });
  }

  export() {
    // No image
    if (!global.imageLoadingState) {
      console.info('Canvas has no image');
      return this.doExport();
    }

    if (global.imageLoadingState && global.imageLoadingState.length > 0) {
      console.warn('Image is loading waiting...');
      setTimeout(this.export, 500);
    } else {
      console.info('Image is ready');
      return this.doExport();
    }
  }

  doExport() {
    const paperX = 550;
    const paperY = 910 * 1.1;
    const designFiles =  _map(this.stages, (stage, surfaceId) => {
      //stage.getStage().draw();
      let dataUrl = stage.getStage().toDataURL({mimeType: 'image/png', pixelRatio: 3, x: 0, y: 0, width: paperX, height: paperY});
      //console.log(dataUrl);

      // FIXME: Retry if image is empty
      if (!dataUrl) {
        dataUrl = stage.getStage().toDataURL({mimeType: 'image/png', pixelRatio: 1, x: 0, y: 0, width: paperX, height: paperY});
        //console.log(dataUrl);
      }

      return {
        id: surfaceId,
        file: dataUrl
      }
    });

    //console.log(designFiles);

    request.post(window.tProjectGlobals.baseUrl + '/designer/submit', {
      body: {
        files: designFiles
      },
      json: true
    }, (err, res, json) => {
      //const json = JSON.parse(body);
      const surfaces = [];

      _each(json, (url, id) => {
        surfaces.push({
          id: id,
          data: this.props.objects.present.objects[id],
          image: url
        })
      });

      const payload = {
        meishi: true,
        amount: this.props.meishi.amount,
        product: this.props.products.currentItem.id,
        color: this.props.products.currentColor.id,
        surfaces: surfaces,
        sizes: _map(this.props.products.sizes, (size) => {
          return {
            id: size.id,
            amount: this.props.products.amount[size.id]
          }
        }),
        user: window.tProjectGlobals.userId,
        coupon: this.props.system.coupon,
        faceImage: this.props.meishi.faceImage.src,
        maskImage: this.props.meishi.maskImage
      };

      //console.log(payload);

      // Fixme: This URL should be optional
      request.post(window.tProjectGlobals.baseUrl + '/designer/checkout', {
        json: payload
      }, (err, res, json) => {
        //console.log(json);

        if (json) {
          // Fixme: This URL should be optional
          window.location.href = window.tProjectGlobals.baseUrl + '/checkout';
        }
      })
    })
  }

  render() {
    return (
      <div className="t-canvas-exporter">
        {_map(this.props.objects.present.surfaces, (surface) => {
          const objects = this.props.objects.present.objects[surface.surface.id];
          if (Object.keys(objects).length > 0) {
            return this.renderSurface(surface);
          }
        })}
      </div>
    );
  }

  renderSurface(surface) {
    const surfaceId = surface.surface.id;
    const objects = this.props.objects.present.objects[surfaceId];
    const index = this.props.objects.present.index[surfaceId];
    //const canvas = surface.surface.canvas;
    const paperX = 550;
    const paperY = 910 * 1.1;
    const ratio = paperX / paperY;
    const baseMaxHeight = paperY;
    const baseMaxWidth = baseMaxHeight * ratio;
    const imageRatio = this.props.meishi.croppedImage.width / this.props.meishi.croppedImage.height;
    //console.log(surface);

    const finalImage = this.props.meishi.finalImage || { x: 0, y: 0, scaleX: 1, scaleY: 1 };

    const imageProps = {
      id: 'face',
      ...this.props.meishi.finalImage,
      props: {
        width: baseMaxWidth,
        height: baseMaxWidth / imageRatio,
        x: finalImage.x,
        y: finalImage.y,
        scaleX: finalImage.scaleX,
        scaleY: finalImage.scaleY,
      }
    }

    return (
      <Stage key={surfaceId} ref={node => {this.stages[surfaceId] = node}} width={paperX} height={paperY} style={{backgroundColor: "transparent"}}>
        <Layer listening={false}>
          {this.props.meishi.finalImage && (<CachedImage listening={false} inline={true} name={'face'} src={this.props.meishi.finalImage.src} props={imageProps.props} />) }
        </Layer>
        <Layer x={0} y={paperY * 0.1} clip={{x: paperX * 0.05, y: 0, width: paperX * 0.9, height: paperY}} listening={false}>
          {index.map(id => {
            return this.renderObject(objects[id], surface);
          })}
          <Group x={0} y={0}>
            <Group x={0} y={0} name='EXtemporaryGroup'/>
          </Group>
        </Layer>
      </Stage>
    );
  }

  /**
   *
   * @param object
   * @param surface
   * @returns {*}
   */
  renderObject(object, surface) {
    switch (object.type) {
      case 'text':
        if (object.props.data) {
          return this.renderTextPath(object, surface);
        } else {
          return this.renderText(object, surface);
        }
      case 'image':
        return this.renderImage(object, surface);
      case 'sticker':
        return this.renderSticker(object, surface);
      case 'group':
        return this.renderGroup(object, surface);
      default:
        return null;
    }
  }

  renderText(object, surface) {
    // const props = {
    //   ...object.props,
    //   x: object.props.x - surface.surface.canvas.x,
    //   y: object.props.y - surface.surface.canvas.y,
    // };
    // return (
    //   <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
    //     <Text name={'export' + object.id} {...object.props} />
    //   </CanvasLayer>
    // );

    let props = object.props;

    if (this.props.sidebar.sizeRef) {
      const paperX = 550;
      const paperY = 910;
      const ratio =  550 / this.props.sidebar.sizeRef.canvasWidth;

      props = {
        ...object.props,
        x: object.props.x * ratio,
        y: object.props.y * ratio,
        fontSize: object.props.fontSize * ratio
      };

      console.log('SIZEREF', props);
    }

    return (
      <Group key={'export' + object.id + '-g'}>
        <Text key={'export' + object.id} name={'export' + object.id} {...props} />
      </Group>);
  }

  renderTextPath(object, surface) {
    const props = {
      ...object.props,
      x: object.props.x - surface.surface.canvas.x,
      y: object.props.y - surface.surface.canvas.y,
    };
    // return (
    //   <CanvasLayer key={object.id} id={object.id} type="text" object={object}>
    //     <TextPath name={'export' + object.id} {...object.props} />
    //   </CanvasLayer>
    // );
    return <TextPath key={'export' + object.id} name={'export' + object.id} {...props} />;
  }

  renderImage(object, surface) {
    let props = object.props;

    if (this.props.sidebar.sizeRef) {
      const paperX = 550;
      const paperY = 910;
      const ratio =  550 / this.props.sidebar.sizeRef.canvasWidth;

      props = {
        ...object.props,
        x: object.props.x * ratio,
        y: object.props.y * ratio,
        scaleX: object.props.scaleX * ratio,
        scaleY: object.props.scaleY * ratio,
      };
    }

    console.log(props);

    return (
      <Group key={'export' + object.id + '-g'}>
        <CachedImage cors={true} key={'export' + object.id} name={'export' + object.id} src={object.src} props={props}/>
      </Group>);
  }

  renderSticker(object, surface) {
    // const props = {
    //   ...object.props,
    //   x: object.props.x - surface.surface.canvas.x,
    //   y: object.props.y - surface.surface.canvas.y,
    // };

    if (object.src.match(/.svg$/)) {
      return (
        <Group key={'export' + object.id + '-g'}>
          <SvgSticker key={'export' + object.id} name={'export' + object.id} props={object.props} object={object}/>
        </Group>
      );
    }

    return (
      <Group key={'export' + object.id + '-g'}>
        <CachedImage cors={true} key={'export' + object.id} name={'export' + object.id} src={object.src} props={object.props}/>
      </Group>
    );
  }

  renderGroup(object, surface) {
    return (
      <Group key={'export' + object.id}>
        {object.index.map(id => {
          const child = object.objects[id];
          const props = {
            ...child.props,
            x: child.props.x - surface.surface.canvas.x,
            y: child.props.y - surface.surface.canvas.y,
          };
          switch (child.type) {
            case 'text':
              if (child.props.data) {
                return (<TextPath name={'export' + child.id} {...props} />);
              } else {
                return (<Text name={'export' + child.id} {...props} />);
              }
            case 'image':
              return (<CachedImage cors={true} name={'export' + child.id} src={child.src} props={props} />);
            default:
              return null;
          }
        })}
      </Group>
    );
  }

}

export default connect(f => f, {}, null, { withRef: true })(Exporter);



// WEBPACK FOOTER //
// ./src/containers/Exporter.js